import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * "Novo X" pedido pela paleta do Ctrl+K: abre o formulário de cadastro desta
 * tela assim que ela monta.
 *
 * O combinado é um `state` de rota (`{ novo: true }`), posto pela
 * `BuscaGlobal` ao navegar — ver `config/buscaGlobal.ts`. Tela que não chama
 * este gancho simplesmente ignora o estado e abre a listagem, que é o pior
 * caso aceitável; por isso a ação funciona em toda parte desde o primeiro dia
 * e vai ficando mais curta conforme as telas vão aderindo.
 *
 * Por que um gancho e não um `useEffect` copiado em cada tela: são sete telas
 * com três formatos diferentes de abrir o formulário (`abrirNovo`,
 * `abrirNova`, um `setState` direto). O que elas têm em comum é exatamente o
 * que está aqui — ler o estado, chamar quem sabe abrir, e limpar.
 *
 * Pode ser chamado em qualquer ponto do corpo do componente, inclusive ANTES
 * da função que abre o formulário: o que se passa é uma seta que só é
 * executada dentro do efeito, depois do render.
 */
export function useAbrirNovo(abrir: () => void): void {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(location.state as { novo?: boolean } | null)?.novo) return;
        abrir();
        /* Limpa o estado da entrada do histórico. Sem isto, um F5 — ou um
           "voltar" até aqui — reabriria o formulário sozinho, e ninguém pediu
           de novo. `replace` para não empilhar uma entrada a mais. */
        navigate(location.pathname + location.search, { replace: true, state: null });
        /* `abrir` é uma seta nova a cada render; entrar nas dependências faria
           o efeito correr sempre. Quem manda é o estado da rota. */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);
}
